import React from 'react';
import { Link, useLocation, Outlet } from 'react-router-dom';
import { UserCircleIcon, CircleStackIcon, CreditCardIcon, ClockIcon, DocumentTextIcon, BookOpenIcon, TicketIcon, PrinterIcon, BellIcon } from '@heroicons/react/24/outline';
import { clsx } from 'clsx';
import Navigation from '../components/Navigation/Navigation';
import BetaBanner from '../components/Navigation/BetaBanner';

const navigation = [
  { name: 'My Library', href: '/library', icon: BookOpenIcon },
  { name: 'Credits', href: '/account/credits', icon: CircleStackIcon },
  { name: 'Notifications', href: '/account/notifications', icon: BellIcon },
  { name: 'Activity Feed', href: '/account/activity', icon: ClockIcon },
  { name: 'Purchase History', href: '/account/purchases', icon: DocumentTextIcon },
  { name: 'Print Jobs', href: '/account/print-jobs', icon: PrinterIcon },
  { name: 'Redeem Coupon', href: '/account/coupons', icon: TicketIcon },
];

export default function AccountLayout() {
  const location = useLocation();

  return (
    <div className="min-h-screen bg-gray-50">
      <div className="sticky top-0 z-50">
        <Navigation />
        <BetaBanner />
      </div>
      
      <div className="flex relative">
        {/* Side Navigation */}
        <div className="w-64 min-h-[calc(100vh-4rem)] bg-white border-r border-gray-200">
          <nav className="flex flex-col p-4 space-y-1">
            {navigation.map((item) => (
              <Link
                key={item.name}
                to={item.href}
                className={clsx(
                  'flex items-center px-4 py-3 text-sm font-medium rounded-lg',
                  location.pathname === item.href
                    ? 'bg-indigo-50 text-indigo-600'
                    : 'text-gray-700 hover:bg-gray-50'
                )}
              >
                <item.icon className="h-5 w-5 mr-3" />
                {item.name}
              </Link>
            ))}
          </nav>
        </div>

        {/* Main Content */}
        <div className="flex-1 px-8 py-6">
          <Outlet />
        </div>
      </div>
    </div>
  );
}